import isBrowser from '../isBrowser';
import EventTarget from './EventTarget';
import normalizeTarget from './normalizeTarget';
var EventStackInner = /** @class */ (function () {
    function EventStackInner() {
        var _this = this;
        this._targets = new Map();
        // ------------------------------------
        // Target utils
        // ------------------------------------
        this._find = function (target, autoCreate) {
            if (autoCreate === void 0) { autoCreate = true; }
            var normalized = normalizeTarget(target);
            if (_this._targets.has(normalized))
                return _this._targets.get(normalized);
            if (!autoCreate)
                return;
            var eventTarget = new EventTarget(normalized);
            _this._targets.set(normalized, eventTarget);
            return eventTarget;
        };
        this._remove = function (target) {
            var normalized = normalizeTarget(target);
            _this._targets.delete(normalized);
        };
        // ------------------------------------
        // Pub/sub
        // ------------------------------------
        this.sub = function (name, handlers, options) {
            if (options === void 0) { options = {}; }
            if (!isBrowser())
                return function () { };
            var _a = options.target, target = _a === void 0 ? document : _a, _b = options.pool, pool = _b === void 0 ? 'default' : _b, _c = options.useCapture, useCapture = _c === void 0 ? false : _c;
            var eventTarget = _this._find(target);
            eventTarget.sub(name, handlers, pool, useCapture);
            return function () { return _this.unsub(name, handlers, options); };
        };
        this.unsub = function (name, handlers, options) {
            if (options === void 0) { options = {}; }
            if (!isBrowser())
                return;
            var _a = options.target, target = _a === void 0 ? document : _a, _b = options.pool, pool = _b === void 0 ? 'default' : _b, _c = options.useCapture, useCapture = _c === void 0 ? false : _c;
            var eventTarget = _this._find(target, false);
            if (eventTarget) {
                eventTarget.unsub(name, handlers, pool, useCapture);
                if (eventTarget.empty())
                    _this._remove(target);
            }
        };
    }
    return EventStackInner;
}());
var eventStack = new EventStackInner();
var EventStackSubscription = /** @class */ (function () {
    function EventStackSubscription(_unsubscribe, isEmpty) {
        if (isEmpty === void 0) { isEmpty = false; }
        this._unsubscribe = _unsubscribe;
        this.isEmpty = isEmpty;
    }
    EventStackSubscription.empty = function () {
        return new EventStackSubscription(function () { }, true);
    };
    EventStackSubscription.prototype.unsubscribe = function () {
        this._unsubscribe();
    };
    return EventStackSubscription;
}());
var EventStack = /** @class */ (function () {
    function EventStack() {
    }
    EventStack.subscribe = function (name, handlers, options) {
        if (options === void 0) { options = {}; }
        var unsubscribe = eventStack.sub(name, function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return handlers.apply(void 0, args);
        }, options);
        return new EventStackSubscription(unsubscribe);
    };
    EventStack.noSubscription = EventStackSubscription.empty();
    return EventStack;
}());
export { EventStack };
